import { useQuery } from '@tanstack/react-query';
import type { Percurso } from 'shared';
import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

export const percursoKeys = {
  mine: (participantId: number) => ['percurso', 'mine', participantId] as const,
};

/**
 * GET /api/participants/{id}/percurso — everything the current participant
 * has done, one stop per day, oldest first.
 */
export function useMyPercurso(participantId: number | undefined) {
  const { isAuthenticated, kind } = useAuthStore();
  const enabled =
    isAuthenticated &&
    kind === 'participant' &&
    typeof participantId === 'number' &&
    participantId > 0;

  return useQuery({
    queryKey:
      typeof participantId === 'number'
        ? percursoKeys.mine(participantId)
        : ['percurso', 'mine', 'unauthenticated'],
    queryFn: () => api.get<Percurso>(`/api/participants/${participantId}/percurso`),
    enabled,
    staleTime: 60_000,
  });
}
